import React from "react";
import { ColumnsType } from "antd/es/table";
import { TFunction } from "i18next";

import { getMimeIcon } from "~/pages/PKD/PKDFiles/model/tableAdapter";

/** Колонки с серверной сортировкой (маппинг в GetDealerReportsSort — на странице). */
export const ACCOUNTING_DEALER_SORTABLE_COLUMNS = [
  "DealerName",
  "lastDate",
  "reportDate",
  "status",
  "updatedAt",
];

export const getAccountingDealerColumns = (
  t: TFunction,
  onDealerNameClick: (record: any) => void,
): ColumnsType<any> => [
  {
    title: t("accounting.DealerName"),
    dataIndex: "DealerName",
    key: "DealerName",
    render: (value: any, record: any) => (
      <span
        style={{ cursor: "pointer", color: "#e37639" }}
        onClick={() => onDealerNameClick(record)}
      >
        {value}
      </span>
    ),
  },
  {
    title: t("accounting.lastDate"),
    dataIndex: "lastDate",
    key: "lastDate",
  },
  {
    title: t("accounting.reportDate"),
    dataIndex: "reportDate",
    key: "reportDate",
  },
  {
    title: t("accounting.status"),
    dataIndex: "status",
    key: "status",
  },
  {
    title: t("accounting.updatedAt"),
    dataIndex: "updatedAt",
    key: "updatedAt",
  },
  {
    title: t("accounting.Files"),
    dataIndex: "Files",
    key: "Files",
    render: (files: any[]) => (
      <div style={{ display: "flex", gap: "4px", flexWrap: "wrap" }}>
        {files?.map((file, i) => (
          <a
            key={i}
            href={file.link}
            download
            target="_blank"
            title={file.name}
            rel="noreferrer"
          >
            {getMimeIcon(file.mimeType, file.link)}
          </a>
        ))}
      </div>
    ),
  },
];
